import styled from "styled-components";
// import { BannerBg } from "../../../ui/AllImages";
import Cookies from "js-cookie";
import { ContactBg } from "../../../ui/AllImages";

export const ContactWrapper = styled.section`
    padding-top: 110px;
    padding-bottom: 0;
    & > *{
        position: relative;
        z-index: 5;
    }
    .containerContact{
        background-image: url(${ContactBg});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        padding: 60px 55px 60px 55px;
        border-radius: 24px;
    }
    .contect-with-us{
        display: block;
        width: 100%;
        /* background-color: var(--bg2); */
        /* border-radius: 16px; */
        padding: 30px 50px 0px 0px;
    }
    .contactComBox{
        padding-top: 30px;
        padding-bottom: 30px;
        border-bottom: 1px solid #1E676D;
        &.no-border{
            border-bottom: none;
        }
    }
    .contact-Us{
        padding-top: 55px;
    }
    .contactDetailCol{
        display: block;
        width: 100%;
        background-color: #114247;
        border-radius: 24px;
        padding: 20px 48px 10px 48px;
        height: 100%;
    }
    .contactComHeading{
        display: flex;
        width: 100%; 
        font-size: 22px;
        color: var(--secondaryColor);
        font-family: var(--familyRbtFlex);
        font-weight: var(--semiBold);
        line-height: 1;
        padding-bottom: 16px;
    }
    .contactText{
        padding: 0 70px 0 70px;
    }
    .contact-text{
        font-family: var(--familyRbt);
        font-weight: var(--medium);
        color: var(--bg2);
        font-size: 18px;
    }
    .contact-info{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 15px;
        & > *{
            width: 100%;
        }
    }
        
    .followHeading{
        margin-top: 30px;
    }
    .addrTxt{
        padding-right: 50px;
    }
    /* .btn-text{
        background: var(--gradient);
        padding: 8px 12px;
        border-radius: 8px;
        & div{
            color:var(--white);
        }
        // & svg{
        //     [fill]{
        //         fill:var(--white);
        //     }
        // }
    } */
    .contactHContainer{
        padding-bottom: 50px;
    }
    .contact-svg{
        /* width: 32px;
        height: 32px;
        background-color: var(--themeColor);
        border-radius: 8px; */

        svg{
            margin: auto;
        }
    }
    .contact-info button,
    .cInfoIt{
        gap: 12px;
        padding: 0;
    }
    
    .contact-wrapper{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 10px;
        position: relative;
        padding:20px 20px;
    }
    .Social-links{
        display: flex;
        width: 100%;
        gap: 12px;
    }
    .contact-links{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 42px;
        height: 42px;
        background-color: var(--themeColor);
        border-radius: 8px;
    }
    body.rtl &{
        padding-top: 70px;
        /* .contact-Us-detail{
            order: 2;
        }
        .contact-Us{
            order: 1;
        } */
        .addrTxt {
            padding-left: 50px;
            padding-right: 0;
            display: inline-block !important;
            span{
                 display: inline-block !important;
            }
        }
        .contactComHeading{
            font-family: var(--arRegular);
        }
        .contactComBox{
            span{
                font-family: var(--arMedium);
            }
        }
        .contect-with-us{
            padding: 30px 0px 0px 50px;
        }
    } 
    @media (max-width: 1199px) {
        .contect-with-us {
            padding: 30px 0px 0px 0px;
        }
        body.rtl &{
            .contect-with-us {
            padding: 30px 0px 0px 0px;
        }
        }
    }

    @media (max-width: 991px) {
        .containerContact > .row{
            gap: 30px;
        }
        .contect-with-us {
            padding: 0px 0px 0px 0px;
        }
        .contact-Us {
            padding-top: 20px;
        }
        body.rtl &{
            .contact-Us-detail{
                order: 1;
            }
            .contact-Us{
                order: 2;
            }
        }
    }
    @media (max-width: 767px) {
        .containerContact > .row{
            gap: 10px;
        }
        .contect-with-us {
            padding: 0;
        }
        .containerContact {
            padding: 40px 20px 50px 20px;
        }
        .contactDetailCol {
            
            padding: 20px 20px 10px 20px;
        }
        .addrTxt {
        padding-right: 0px;
        }
        body.rtl &{
            .contect-with-us {
            padding: 0px 0px 0px 0px;
        }
        }
    }
`
export const ContactFormWrapper = styled.div`
    .field-box{
        display: flex;
        flex-direction: column;
        gap:2px;
        margin:0px 0 15px 0;
        
    }
    .input-field,
    .file-attached{
        padding: 10px 15px;
        border-radius: 10px;
        border: none;
        outline: none;
        color: var(--black);
        background-color: transparent;
        border: 1px solid #3D6A6D;
        font-size: 16px;
        font-family: var(--regular);
        color: var(--text2);
    }

    .input-field::placeholder{
        color: #3D6A6D;
    }
    .error-message{
        font-family: var(--regular);
        /* border: 1px solid #ff00004f; */
        color: #d40404 !important;
        /* padding: 6px 8px; */
        font-size: 14px;
        margin-bottom: 0;
        /* background: #ff00004f; */
        /* -webkit-text-fill-color: white; */
    }
    .loading-btn{
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        background: #0b0b0b9c;
        text-align: center;
        top: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        color:var(--white);
        font-family:var(--regular);
        border-radius: 28px;

    }
    .contact-social-links{
        position: relative;
        left: 15px;
    }
    .contactBtn{
        display: flex;
        background-color: var(--themeColor);
        padding: 11px 30px;
        border-radius: 10px;
        color: var(--white);
        font-size: 17px;
        font-family: var(--bold);
        transition: all .4s ease-in-out;
        border: none;
        &:hover{
            background-color: var(--hoverBg);
            border: none;
        }
    }
    body.rtl &{
        .input-field,
        .file-attached{
            font-family: var(--arLT);
        }
        .field-box p{
            font-family: var(--arLT);
        }
        .Toastify__toast{
            font-family: var(--arLT);
        }
        .Toastify__close-button{
            left: 6px;
            right: auto;
        }
    }
    @media (max-width: 767px) {
        .field-box{
            margin:0px 0 5px 0;
        }
        .contact-btn{
            margin-bottom: 0 !important;
        }
    }
`